import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { updateMasterServiceInOrderMSServices } from '../orderMSServices/mockData'
import { requireAuthenticatedUser } from '../../decorators'
import {
  getOrderMasterServiceListData,
  getPotentialLocationSelectItemListDataByMOMSId,
  getOrderDataByOrderMasterServiceId,
  getCompanyDataByOrderMasterServiceId,
  getSupplierListDataByOrderMasterServiceId,
} from './mockData'
import type { ICompany } from '~/types/company/models'
import type { IOrder } from '~/types/order/models'
import type { IEntitySelectItemWithOptionalAvatar } from '~/types/models'

// async function getOrderMasterServices(
//   req: RestRequest,
//   res: ResponseFunction,
//   ctx: RestContext
// ) {
//   console.log(`'Returning ordermasterservices.`)
//   return res(ctx.status(200), ctx.json({ items: getOrderMasterServiceListData() }))
// }

async function getPotentialLocations(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const { id } = req.params
  if (typeof id !== 'string') {
    const responseBody = {
      statusCode: 500,
      message: 'Passed ID is not a string.',
    }
    return res(ctx.status(500), ctx.json(responseBody))
  }
  console.log(
    `'Returning potential locations for service of orderMasterService id ${id}.`
  )
  return res(
    ctx.status(200),
    ctx.json({
      data: await getPotentialLocationSelectItemListDataByMOMSId(id),
    })
  )
}

interface GetCompanyFromOrderMasterServiceResponse {
  data: ICompany
}

async function getCompanyFromOrderMasterService(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const { id } = req.params
  if (typeof id !== 'string') {
    const responseBody = {
      statusCode: 500,
      message: 'Passed ID is not a string.',
    }
    return res(ctx.status(500), ctx.json(responseBody))
  }
  try {
    const responseBody: GetCompanyFromOrderMasterServiceResponse = {
      data: await getCompanyDataByOrderMasterServiceId(id), // will either be valid or will have thrown error
    }
    return res(ctx.status(200), ctx.json(responseBody))
  } catch (e: unknown) {
    const responseBody = {
      statusCode: 404,
      message: `Can't get Company from orderMasterService ${id}: ${e.message}`,
    }
    return res(ctx.status(404), ctx.json(responseBody))
  }
}

interface GetOrderFromOrderMasterServiceResponse {
  data: IOrder
}

async function getOrderFromOrderMasterService(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const { id } = req.params
  if (typeof id !== 'string') {
    const responseBody = {
      statusCode: 500,
      message: 'Passed ID is not a string.',
    }
    return res(ctx.status(500), ctx.json(responseBody))
  }
  try {
    const responseBody: GetOrderFromOrderMasterServiceResponse = {
      data: await getOrderDataByOrderMasterServiceId(id), // will either be valid or will have thrown error
    }
    return res(ctx.status(200), ctx.json(responseBody))
  } catch (e: unknown) {
    const responseBody = {
      statusCode: 404,
      message: `Can't get Order from orderMasterService ${id}: ${e.message}`,
    }
    return res(ctx.status(404), ctx.json(responseBody))
  }
}

interface GetSuppliersFromOrderMasterServiceResponse {
  data: IEntitySelectItemWithOptionalAvatar[]
}

async function getSuppliersFromOrderMasterService(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const { id } = req.params
  if (typeof id !== 'string') {
    const responseBody = {
      statusCode: 500,
      message: 'Passed ID is not a string.',
    }
    return res(ctx.status(500), ctx.json(responseBody))
  }
  const onlyWithReadyForContractMSServices =
    req.url.searchParams.get('onlywithreadyforcontractmsservices') === 'true'
  try {
    const responseBody: GetSuppliersFromOrderMasterServiceResponse = {
      data: await getSupplierListDataByOrderMasterServiceId(
        id,
        onlyWithReadyForContractMSServices
      ),
    }
    return res(ctx.status(200), ctx.json(responseBody))
  } catch (e: unknown) {
    const responseBody = {
      statusCode: 404,
      message: `Can't get Suppliers from orderMasterService ${id}: ${e.message}`,
    }
    return res(ctx.status(404), ctx.json(responseBody))
  }
}

// post

const postOrderMasterService = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getOrderMasterServiceListData)
}

const patchOrderMasterService = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getOrderMasterServiceListData, [
    updateMasterServiceInOrderMSServices,
  ])
}

const deleteOrderMasterServices = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getOrderMasterServiceListData)
}

export const handlers = [
  // {
  //   method: 'get',
  //   path: '/api/ordermasterservices',
  //   handler: getOrderMasterServices,
  // },
  {
    method: 'get',
    path: '/api/ordermasterservices/:id/potentiallocations',
    handler: getPotentialLocations,
  },
  {
    method: 'get',
    path: '/api/ordermasterservices/:id/company',
    handler: getCompanyFromOrderMasterService,
  },
  {
    method: 'get',
    path: '/api/ordermasterservices/:id/order',
    handler: getOrderFromOrderMasterService,
  },
  {
    method: 'get',
    path: '/api/ordermasterservices/:id/suppliers',
    handler: getSuppliersFromOrderMasterService,
  },
  {
    method: 'post',
    path: '/api/ordermasterservices',
    handler: postOrderMasterService,
  },
  {
    method: 'patch',
    path: '/api/ordermasterservices/:id',
    handler: patchOrderMasterService,
  },
  {
    method: 'delete',
    path: '/api/ordermasterservices/:id',
    handler: deleteOrderMasterServices,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
